import { FC } from "react";
import {
  IModifiedOrderAcceptanceTimeStats,
} from "../../../models/statistcs/respons";
import OrderStatusStatsCard from "../order-status-stats-card";

interface IProps {
  stats?: IModifiedOrderAcceptanceTimeStats;
  onChange: (stats: IModifiedOrderAcceptanceTimeStats) => void;
  hideDateControls?: boolean;
}

const ModifiedOrderAcceptanceTimeStats: FC<IProps> = ({
  stats,
  onChange,
  hideDateControls,
}) => (
  <OrderStatusStatsCard
    stats={stats}
    onChange={onChange}
    hideDateControls={hideDateControls}
    titleKey="modified_order_acceptance_time_stats"
    averageLabelKey="average_modified_order_acceptance_time"
    averageField="averageAcceptanceMinutes"
    includedField="includedOrderCount"
    includedLabelKey="included_orders"
    excludedField="excludedOrderCount"
    excludedTooltipKey="excluded_modified_order_acceptance_orders_tooltip"
    metrics={[
      { labelKey: "median", field: "medianAcceptanceMinutes", format: "minutes" },
      { labelKey: "p90", field: "p90AcceptanceMinutes", format: "minutes" },
      { labelKey: "outlier_rate", field: "outlierRate", format: "percent" },
      {
        labelKey: "near_timeout_orders",
        field: "nearTimeoutOrderCount",
        format: "number",
      },
      {
        labelKey: "repeated_customer_acceptance_rate",
        field: "repeatedCustomerAcceptanceRate",
        format: "percent",
      },
      {
        labelKey: "unavailable_product_order_rate",
        field: "unavailableProductOrderRate",
        format: "percent",
      },
      { labelKey: "unavailable_products", field: "unavailableProductCount" },
    ]}
    tables={[
      {
        key: "areas",
        labelKey: "areas",
        rows: (value) => [
          ...(value.areas || []),
          ...(value.outsideAreas ? [value.outsideAreas] : []),
        ],
        rowKey: (row, index) => `area-${row.areaId ?? index}`,
        columns: [
          { labelKey: "area", field: "areaName", width: 220 },
          { labelKey: "orders", field: "orderCount", width: 110 },
          {
            labelKey: "average",
            field: "averageAcceptanceMinutes",
            format: "minutes",
            width: 140,
          },
          {
            labelKey: "median",
            field: "medianAcceptanceMinutes",
            format: "minutes",
            width: 140,
          },
          {
            labelKey: "p90",
            field: "p90AcceptanceMinutes",
            format: "minutes",
            width: 140,
          },
          {
            labelKey: "outlier_rate",
            field: "outlierRate",
            format: "percent",
            width: 130,
          },
          {
            labelKey: "near_timeout_rate",
            field: "nearTimeoutOrderRate",
            format: "percent",
            width: 150,
          },
          {
            labelKey: "unavailable_product_order_rate",
            field: "unavailableProductOrderRate",
            format: "percent",
            width: 180,
          },
        ],
      },
    ]}
  />
);

export default ModifiedOrderAcceptanceTimeStats;
